import React, { useState } from "react";

export default function VerifiedBatches(){

  const [activeBatch, setActiveBatch] = useState(null);

  const batches = [
    {name:"Retatrutide", batch:"NP2408", purity:"99.21%"},
    {name:"Tesamorelin", batch:"NP2411", purity:"99.34%"},
    {name:"BPC-157", batch:"NP2413", purity:"99.11%"},
    {name:"MOTS-c", batch:"NP2416", purity:"99.28%"},
    {name:"KLOW-80", batch:"NP2420", purity:"99.18%"},
    {name:"GHK-CU", batch:"NP2422", purity:"99.30%"},
    {name:"DSIP", batch:"NP2425", purity:"99.26%"},
    {name:"5-Amino-1MQ", batch:"NP2427", purity:"99.17%"},
  ];

  return(

    <div className="batch-section">

      <h2>Verified Laboratory Batches</h2>

      <p className="batch-sub">
        Independent analytical testing confirms the purity of every batch.
      </p>

      <div className="batch-grid">

        {batches.map((b,i)=>(
          <div key={i} className="batch-card">

            <div className="batch-card-top">

              <h4 className="batch-name">{b.name}</h4>

              <span className="batch-verified">✓ Verified</span>

            </div>

            <div className="batch-info">

              <div className="batch-line">
                <span>Batch ID</span>
                <p>{b.batch}</p>
              </div>

              <div className="batch-line">
                <span>Purity</span>
                <p>{b.purity}</p>
              </div>

            </div>

            <div className="batch-purity-wrapper">

              <div className="batch-purity-bar">

                <div
                  className="batch-purity-fill"
                  style={{ width: `${parseFloat(b.purity)}%` }}
                ></div>

              </div>

              <div className="batch-purity-label">
                {b.purity} HPLC Verified
              </div>

            </div>

            <button
              className="coa-btn"
              onClick={() => setActiveBatch(b)}
            >
              View COA
            </button>

          </div>
        ))}

      </div>

      {activeBatch && (
        <div className="coa-modal-overlay" onClick={() => setActiveBatch(null)}>

          <div
            className="coa-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <h3>Certificate of Analysis</h3>

            <p><strong>Compound:</strong> {activeBatch.name}</p>
            <p><strong>Batch:</strong> {activeBatch.batch}</p>
            <p><strong>Purity:</strong> {activeBatch.purity}</p>
            <p><strong>Method:</strong> HPLC</p>
            <p><strong>Status:</strong> Verified</p>

            <button
              className="coa-close"
              onClick={() => setActiveBatch(null)}
            >
              Close
            </button>

          </div>

        </div>
      )}

    </div>

  )
}